import React from "react";

// Chakra imports
import {
  Icon,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Spinner,
} from "@chakra-ui/react";
// Assets
import { MdOutlineMoreHoriz, MdOutlineCardTravel } from "react-icons/md";
import axios from "axios";
import ApiService from "services/api.js";

export default function Banner(props) {
  const { urlExcel, ...rest } = props;
  const textColor = useColorModeValue("secondaryGray.500", "white");
  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "unset" },
    { color: "secondaryGray.500", bg: "unset" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("white", "whiteAlpha.100");
  const bgShadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const OverlayOne = () => (
    <ModalOverlay
      bg="blackAlpha.300"
      backdropFilter="blur(10px) hue-rotate(0deg)"
    />
  );
  const [overlay, setOverlay] = React.useState(<OverlayOne />);
  // Ellipsis modals
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure({ defaultIsOpen: false });

  const { isOpen, onOpen, onClose } = useDisclosure();

  // Extract date parameters from URL or use them directly from state
  const extractDateParams = (url) => {
    // Check if URL contains params
    if (
      url.includes("?") &&
      url.includes("from_order_date") &&
      url.includes("to_order_date")
    ) {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      return {
        dateFrom: params.get("from_order_date"),
        dateTo: params.get("to_order_date"),
      };
    }

    // For old-style URLs with embedded dates
    try {
      // Find the dates in the URL pattern like .../YYYY-MM-DD/YYYY-MM-DD
      const datePattern = /\/(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2})/;
      const matches = url.match(datePattern);

      if (matches && matches.length >= 3) {
        return {
          dateFrom: matches[1],
          dateTo: matches[2],
        };
      }
    } catch (error) {
      console.error("Error extracting dates from URL:", error);
    }

    // Default dates - current month
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      dateFrom: firstDay.toISOString().slice(0, 10),
      dateTo: today.toISOString().slice(0, 10),
    };
  };

  // Extract branch IDs from the URL parameter
  const extractBranchIds = (url) => {
    // For new URL format with query parameters
    if (url.includes("?") && url.includes("branch_ids=")) {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      const branchIdsParam = params.get("branch_ids");

      if (branchIdsParam) {
        // Return the branch IDs directly from the URL (e.g., "TK12,TK24,TK28")
        return branchIdsParam;
      }
    }

    // For old-style URLs with embedded branch ID
    try {
      // Find branch ID pattern in URL (modify this regex if needed)
      const branchPattern = /\/([^\/]+)\/\d{4}-\d{2}-\d{2}/;
      const matches = url.match(branchPattern);

      if (matches && matches.length >= 2) {
        return matches[1]; // Single branch ID
      }
    } catch (error) {
      console.error("Error extracting branch ID from URL:", error);
    }

    return ""; // Default if no branch ID found
  };

  // Extract module name from URL (pb1, dataCore, dataCoreCancel, dataEOD)
  const extractModuleName = (url) => {
    try {
      // Remove protocol and domain
      let path = url;

      // If URL contains http:// or https://
      if (url.includes("://")) {
        const urlObj = new URL(url);
        path = urlObj.pathname;
      }

      // Extract the first segment after the leading slash
      const pathParts = path.split("/").filter((part) => part.length > 0);
      let segment = 1;
      if (pathParts.length > 0) {
        if (pathParts[segment] === "a") {
          segment++;
        }
        return pathParts[segment]; // Return first segment (pb1, dataCore, etc.)
      }
    } catch (error) {
      console.error("Error extracting module name from URL:", error);
    }

    return "report"; // Default fallback name
  };

  const openInNewTab = async (url) => {
    try {
      setOverlay(<OverlayOne />);
      onOpen(true);

      // Extract dates from URL
      const { dateFrom, dateTo } = extractDateParams(url);

      // Calculate date difference
      const startDate = new Date(dateFrom);
      const endDate = new Date(dateTo);
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

     // console.log(
      //   "Date range:",
      //   dateFrom,
      //   "to",
      //   dateTo,
      //   "(" + diffDays + " days)"
      // );

      if (diffDays <= 31) {
        // Get user data from localStorage
        const userData = localStorage.getItem("verified_user");

        if (!userData) {
          console.error("No user data found in localStorage");
          onClose(true);
          return;
        }

        const userObject = JSON.parse(userData);
        const userEmail = userObject.email; // Get the user's email

        if (url.includes("/all/") || url.includes("branch_ids=")) {
          // Extract branch IDs from roleBranch array
          //const branchIds = userObject.roleBranch.map(branch => branch.id);
          const branchIds = extractBranchIds(url);
          const moduleName = extractModuleName(url);

          // Combine all branch IDs into a single parameter
          if (url.includes("?")) {
            // Using new URL format with query parameters
            const urlObj = new URL(url);
            const params = new URLSearchParams(urlObj.search);

            // Join all branch IDs with commas
            // params.set('branch_ids', branchIds.join(','));
            // urlObj.search = params.toString();

            const response = await axios.get(
              urlObj.toString(),
              await ApiService.optionsFile()
            );

            // Process download
            const downloadUrl = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute(
              "download",
              `fileexport_${moduleName}_${userEmail}_${new Date()
                .toJSON()
                .slice(0, 10)}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            // For old URL format, we'll use the first branch in the list or 'all'
            // You may need to adjust this based on your API's requirements
            const branchIndex = url.indexOf("/all/");
            if (branchIndex > 0) {
              const modifiedUrl =
                url.slice(0, branchIndex + 1) +
                (branchIds || "all") + // Use "all" to get all branches
                url.slice(branchIndex + 4);

              const response = await axios.get(
                modifiedUrl,
                await ApiService.optionsFile()
              );

              // Process download
              const downloadUrl = window.URL.createObjectURL(
                new Blob([response.data])
              );
              const link = document.createElement("a");
              link.href = downloadUrl;
              link.setAttribute(
                "download",
                `fileexport_${moduleName}_${userEmail}_${new Date()
                  .toJSON()
                  .slice(0, 10)}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        } else {
          // Single branch export
          const response = await axios.get(url, await ApiService.optionsFile());

          // Process download
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;

          link.setAttribute(
            "download",
            "fileexport_" +
              userEmail +
              "_" +
              new Date().toJSON().slice(0, 10) +
              ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } else {
        setOverlay(<OverlayOne />);
        onOpen2(true);
      }
    } catch (error) {
      console.error("Error during export:", error);
    } finally {
      onClose(true);
    }
  };

  function callExportFunction(urlExcel) {
    setOverlay(<OverlayOne />);
    onOpen(true);
    openInNewTab(urlExcel);
  }

  return (
    <Menu isOpen={isOpen1} onClose={onClose1}>
      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        {overlay}
        <ModalContent>
          <ModalHeader>Please Wait</ModalHeader>
          <ModalBody ml={175}>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </ModalBody>
          <ModalBody ml={125}>Processing Your Request</ModalBody>
        </ModalContent>
      </Modal>

      <Modal isCentered isOpen={isOpen2} onClose={onClose2}>
        {overlay}
        <ModalContent>
          <ModalHeader color="red.600">Error</ModalHeader>
          <ModalBody>
            <Text fontSize="lg" fontWeight="bold" mb="1rem">
              Tidak Bisa Mengekspor Excel Lebih Dari 31 Hari
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
      <MenuButton
        align="center"
        justifyContent="center"
        bg={bgButton}
        _hover={bgHover}
        _focus={bgFocus}
        _active={bgFocus}
        w="37px"
        h="37px"
        lineHeight="100%"
        onClick={onOpen1}
        borderRadius="10px"
        {...rest}
      >
        <Icon as={MdOutlineMoreHoriz} color={iconColor} w="24px" h="24px" />
      </MenuButton>
      <MenuList
        w="200px"
        minW="unset"
        maxW="200px !important"
        border="transparent"
        backdropFilter="blur(63px)"
        bg={bgList}
        boxShadow={bgShadow}
        borderRadius="20px"
        p="15px"
      >
        <MenuItem
          transition="0.2s linear"
          p="0px"
          borderRadius="8px"
          color={textColor}
          _hover={textHover}
          _active={{
            bg: "transparent",
          }}
          _focus={{
            bg: "transparent",
          }}
          mb="5px"
          onClick={() => callExportFunction(urlExcel)}
        >
          <Flex align="center">
            <Icon as={MdOutlineCardTravel} h="16px" w="16px" me="8px" />
            <Text fontSize="sm" fontWeight="400">
              Export To Excel
            </Text>
          </Flex>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
